var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_c('div',{staticClass:"pageslide"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }